import styled from "styled-components";

export const CountryData = styled.div<{theme: string}>`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  color: ${props => props.theme === 'light' ? '' : '#FFF'};
  img {
    width: 440px;
    height: 300px;
  }
  .data-area{
    display: flex;
    flex-direction: column;
    justify-content: center;

    h1{
      margin: 0
    }
    .data-firstArea{
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      margin-top: 20px;
      
      p{
        margin: 5px 0;
        span{
          font-weight: 800;
        }
      }
      .language{
        font-weight: normal;
        margin-right: 5px;
      }
    }
    .border-area{
      margin-top: 20px;
      p{
        font-weight: 800;
      }
      .borders{
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        grid-gap: 5px;
        width: 100%;

        a{
          text-decoration: none;
          color: ${props => props.theme === 'light' ? '#000' : '#FFF'};
          display: flex;
          min-height: 25px;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          font-size: 13px;
          font-weight: 300;
          box-shadow: 1px 1px 1rem rgba(0, 0, 0, 0.2);border-radius : 4px;
        }
        a:hover{
          transform: scale(1.05)
        }
      }
    }
  }
  @media(min-width: 768px) and (max-width: 1023px){
    &{
      img{
        width: 340px;
        height: 200px;
      }
      .data-area{
        h1{
          font-size: 28px;
        }
        .data-firstArea{
          p, span{
            font-size:14px;
          }
        }
        .border-area{
          p,span, a{
            font-size: 14px
          }
        }
      }
    }
  }
  @media(max-width: 767px){
    &{
      grid-template-columns: 1fr;

      img{
        margin:auto;
        width: 280px;
        height: 180px;
      }
      .data-area{
        width: 280px;
        margin: auto;
        margin-top: 30px;

        h1{
          font-size: 17px;
        }
        .data-firstArea{
          grid-template-columns: 1fr;;
          p, span{
            font-size: 12px;
          }
          .topLevel{
            margin-top: 40px;
          }
        }
        .border-area{
          .borders{
            grid-template-columns: repeat(3, 1fr);
          }
          p, span, a{
            font-size: 14px;
          }
        }
      }
    }
  }
`